import Vue from "vue";
import Vuex from "vuex";
import pagination from "./mutations/pagination";
import server from "./mutations/server";
import consts from "./mutations/consts";
import menuTab from "./mutations/menuTab";
import variable from "./mutations/variable";
import permission from "./mutations/permission";
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  modules: {
    pagination,
    server,
    consts,
    menuTab,
    variable,
    permission, // 注册新的 permission 模块
  },
  mutations: {},
  actions: {},
  getters: {},
  // 只持久化业务状态模块；pagination 不持久化，
  // 保证分页默认值始终跟随代码，避免 localStorage 旧值覆盖
  plugins: [
    createPersistedState({
      paths: ["server", "consts", "menuTab", "variable", "permission"],
    }),
  ],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js